<div class="page-detail">
    <div class="page-detail-content">
        <cp-page-view [title]="pageTitle" [details]="details" [breadcrumbs]="breadcrumbs"></cp-page-view>
    </div>
</div>
